import { QRButtonContainer } from './QRButton.styles'
import QRIcon from '../QRIcon/QRIcon'

export interface QRButtonProps {
    onClick: () => void
}

const QRButton = ({ onClick }: QRButtonProps) => {
    return (
        <QRButtonContainer onClick={onClick}>
            <QRIcon />
        </QRButtonContainer>
    )
}

export default QRButton
